import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import "@/components/membership/Dashboard/Dashboard.css";

const DashboardHeader = ({ onFilterChange, dashboard, filter }) => {
  const [activeBox, setActiveBox] = useState(undefined);
  const [currentFilter, setCurrentFilter] = useState("clear");

  const changeFilter = (value) => {
    if (value === currentFilter) {
      setCurrentFilter("clear");
      onFilterChange("clear");
      setActiveBox(undefined);
    } else {
      setCurrentFilter(value);
      onFilterChange(value);
      setActiveBox(value);
    }
  };

  useEffect(() => {
    if (filter === "clear") {
      setCurrentFilter("clear");
      setActiveBox(undefined);
    }
  }, [filter]);

  const headerData = {
    Processing: {
      label: "Processing",
      text: dashboard.processing,
      color: "var(--seiu-blue)",
    },
    "Held Up": {
      label: "Held Up",
      text: dashboard.held_up,
      color: "var(--seiu-red)",
    },
  };

  return (
    <div className="dashboardstyle-headerContainer">
      <Typography variant="h5" className="dashboardstyle-headerTitle">
        Submission Overview
      </Typography>
      <Box className="dashboardstyle-boxContainer">
        {Object.values(headerData).map((data, index) => {
          return (
            <Box
              key={index}
              className={`dashboardstyle-box ${
                activeBox === data.label ? "active-dashboardstyle-box" : ""
              }`}
              onClick={() => changeFilter(data.label)}
            >
              <Typography
                variant="h5"
                sx={[{ color: data.color }]}
                className="dashboardstyle-number"
              >
                {data.text}
              </Typography>
              <Typography
                sx={[{ color: data.color }]}
                className="dashboardstyle-descriptor"
              >
                {data.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </div>
  );
};

DashboardHeader.propTypes = {
  onFilterChange: PropTypes.func,
  dashboard: PropTypes.object,
  filter: PropTypes.string,
};

export default DashboardHeader;
